module.exports = __webpack_public_path__ + "AmanAlmadi-1faf85ab.webp";